export class Guid {
  static readonly empty = "00000000-0000-0000-0000-000000000000";
  private value = Guid.empty;

  constructor(_value?: string) {
    if (_value) {
      if (Guid.isValid(_value)) {
        this.value = _value;
      }
    } else {
      this.value = Guid.empty;
    }
  }

  static isValid(str: string): boolean {
    const validRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return validRegex.test(str);
  }

  toString() {
    return this.value;
  }

  toJSON(): string {
    return this.value;
  }

  static newGuid(): Guid {
    const str = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });

    return new Guid(str);
  }
}
